import React from 'react';
import './RegistrationCertificate.css';
import { t } from 'i18next';

const RegistrationCertificate = () => {
  return (
    <div className="main-container relative px-6 pt-6">
      <img
        src={`https://esscanpstorage.blob.core.windows.net/esscimages/cert-blackwavedesign.svg`}
        alt="cert-design"
        className="absolute bottom-0 left-0 w-full"
      />
      <div className="h-full border-l-2 border-r-2 border-t-2 border-black">
        <div className="flex flex-col items-center justify-center">
          <div className="flex gap-2">
            <div className="mt-5 flex pb-4">
              <img
                className="w-12 lg:w-16"
                src={`https://esscanpstorage.blob.core.windows.net/esscimages/AnpLogo.png `}
                alt={t('anpLogo', 'ANP Logo')}
              />
              <h6 className="logo-text ml-2 mt-2 text-[10px] font-light sm:text-[10px] sm:font-light md:text-[10px] md:font-semibold lg:text-[14px] lg:font-bold">
                {t('enterpriseSupportServiceCenter', 'Enterprise Support Service Center')}
              </h6>
              {/* <div className="ml-1 border-r-4 border-yellow-300"></div> */}
            </div>
            {/* <div className="mt-5 flex pb-4">
              <img
                className="w-12 sm:w-12 md:w-12 lg:w-16"
                src={`https://esscanpstorage.blob.core.windows.net/esscimages/AnpLogo2.png`}
                alt={t('anpLogo2', 'ANP Logo')}
              />
              <h6 className="logo-text2 ml-2 mt-2 text-[10px] font-light sm:text-[10px] sm:font-light md:text-[10px] md:font-semibold lg:text-[14px] lg:font-bold">
                {t('autoridadeNacional', 'Autoridade Nacional')}
                <br />
                {t('DoPetroleo', 'Do Petroleo')}
                <br />
                {t('timorLeste', 'Timor - Leste')}
              </h6>
            </div> */}
          </div>
          <div className="mt-4 text-center">
            <p className="text-4xl">Certificate</p>
            <h1 className="mb-2 mt-2 text-4xl font-extrabold">OF REGISTRATION</h1>
            <p className="mb-12 text-xl text-gray-600">This is to Certify that</p>
            <div className="border-b-2 border-black"></div>
            <p className="mt-2 text-center">
              has duly registered with Autoridade Nacional Do Petroleo Timor-Leste on the <br />
              Enterprise Support Service Portal and is hereby granted authorization to operate{' '}
              <br />
              under the rules and regulations of Autoridade Nacional Do Petroleo Timor-Leste. <br />
              This certificate is issued in recognition of the compliance with all the necessary{' '}
              <br />
              requirements and shall remain valid unless revoked in accordance with <br />
              the applicable laws and regulations.
            </p>
          </div>
        </div>
        <div className="mt-5 flex justify-around">
          <div className="mt-16 w-[150px] border-t-2 border-black pt-1">
            <p className="text-center">Issue Date</p>
          </div>
          <div className="z-10">
            <img
              src={`https://esscanpstorage.blob.core.windows.net/esscimages/CertStamp.svg`}
              alt="stamp"
              className="h-[180px] w-[180px]"
            />
          </div>
          <div className="mt-16 border-t-2 border-black pt-1">
            <p className="text-center">Authorized Signature</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationCertificate;
